module.exports = {
      id: "android-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#android",
      toString: function () {
        return this.url;
      }
    }